<template>
  <v-main class="fill-height">
    <v-container
      class="fill-height"
      fluid
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
          <v-card class="elevation-12">
            <v-toolbar
              color="black"
              dark
              flat
            >
              <v-toolbar-title>Вход по ссылке</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-progress-linear
                v-if="loading"
                indeterminate
                color="primary"
                class="mb-2"
              />
              <v-alert
                v-if="linkError"
                type="error"
                dense
                outlined
                class="mt-2"
              >
                {{ linkError }}
              </v-alert>
              <p
                v-else-if="!loading && !linkError"
                class="text-body-2 grey--text"
              >
                Выполняется вход…
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'PortalLinkView',
  data() {
    return {
      loading: true,
      linkError: '',
    };
  },
  mounted() {
    this.signInByLink();
  },
  methods: {
    ...mapActions('auth', ['LINK_SIGNIN']),
    signInByLink() {
      const slug = this.$route.params.slug;
      if (!slug) {
        this.linkError = 'Ссылка не найдена или недействительна.';
        this.loading = false;
        return;
      }
      this.LINK_SIGNIN(slug)
        .then(() => {
          this.$router.replace('/');
        })
        .catch((error) => {
          this.loading = false;
          const detail = error.response?.data?.detail;
          this.linkError = typeof detail === 'string' ? detail : 'Ссылка не найдена или недействительна.';
        });
    },
  },
};
</script>
